import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createSetEffortCommand } from '../../../api/commands/factory/createPrioCommands';
import { Effort } from '../../../api/queries';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetEffort extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetEffort';

    public constructor(public cardId: string, public effort: Effort) {
        super(SetEffort.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetEffort): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createSetEffortCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetEffort): void => {
    const card = state.subtasks.find((x) => x.id === action.cardId);

    card.effort = action.effort;
    card.lastUpdatedAt = new Date();
};

//@ts-ignore
registerMiddleware(SetEffort.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetEffort.ACTION_TYPE, reducer);
